import readExcelFile from 'read-excel-file/browser';

const timelineElement = document.getElementById("timeline");
var timeline;
var timelineFiltered = [];
var timelineBin = [];

var testel = document.createElement("input");
testel.setAttribute("type","file");

testel.addEventListener("change", async () => {
    console.log("NEW FILE");
    const data = await readExcelFile(testel.files[0]);
    
    const enableTestFunction = document.getElementById("enableTestFunction");
    if(enableTestFunction.checked){
        console.log(data);
        runTests(data);
    }
    timeline = compileSheets(data);
    //console.log(timeline);

    // filters.time[0]=timeline[0].date;
    // filters.time[1]=timeline[timeline.length-1].date;
    document.getElementById("limitdate1").value=formatSetDate(timeline[0].date);
    document.getElementById("limitdate2").value=formatSetDate(timeline[timeline.length-1].date);

    regenerateTimeline(timeline, document.getElementById("timeline"));
});
document.body.appendChild(testel); 

function formatLocDate(date){
    if(date==null)return null;
    let ret = new Date();
    //console.log(date);
    ret.setUTCFullYear(date.slice(6,10));
    ret.setUTCMonth(date.slice(3,5));
    ret.setUTCDate(date.slice(0,2));
    ret.setUTCHours(date.slice(11, 13));
    ret.setUTCMinutes(date.slice(14,16));
    ret.setUTCSeconds(date.slice(17,19));

    return ret;
}
function formatYNToBinary(yn){
    if(yn=="Yes")return true;
    return false;
}

function formatSetDate(date){
    //console.log(date);
    let month=(date.getMonth()+1).toString();
    if(month.length==1){month="0"+month;}
    let day=date.getDate().toString();
    if(day.length==1){day="0"+day;}
    //console.log(date.getFullYear()+"-"+month+"-"+day);
    return date.getFullYear()+"-"+month+"-"+day;
}

// Just bubble sort this - we're at the 'just work' stage, not the 'work well' stage.
function sortByDate(list){
    while(true){
        let loop=false;
        for(let i=1; i<list.length;i++){
            if(list[i].date<list[i-1].date){
                loop=true;
                let placeholder=list[i];
                list[i]=list[i-1];
                list[i-1]=placeholder;
            }
        }
        if(!loop){break;}
    }

    return list;
}

function regenerateTimeline(list, el){
    while(el.firstChild){el.removeChild(el.lastChild);}
    
    let date1=list[0].date;
    let date2=list[list.length-1].date;

    for(let i=0;i<list.length;i++){
        let newel = document.createElement("div");
        newel.setAttribute("class","marker");
        const elementWidth = 3; // Make dynamic later
        let timelineProgress = (100*(list[i].date-date1))/(date2-date1);
        newel.style.left="calc("+timelineProgress+"% - "+(timelineProgress/100)*elementWidth+"px)";
        newel.style.width = elementWidth + "px";
        newel.setAttribute("filtertype",list[i].type);

        // Stick basic details in dropdown
        let dropdown = document.createElement("div");
        dropdown.classList.add("dropdown");
        let listify = [["type",list[i].type],["date",list[i].date]];
        for(let j=0;j<listify.length;j++){
            let p = document.createElement("p");
            p.textContent=listify[j][0]+": "+listify[j][1];

            dropdown.appendChild(p);
        }
        newel.appendChild(dropdown);

        // Put full info in 'itemdetails' div on click
        newel.addEventListener("click", (e) => {updateItemDetails(list[i]);});

        el.appendChild(newel);
    }
}

const itemDetails = document.getElementById("itemdetails");
function updateItemDetails(instance){
    //console.log(instance.target);
    while(itemDetails.firstChild){itemDetails.removeChild(itemDetails.lastChild);}

    for(var i in instance){
        let newel = document.createElement("p");
        newel.textContent = i +": "+ instance[i];
        switch(i){
            case "date":
                newel.classList.add("contextable"); // For clarity
                newel.title = "Right-click to shift the timeline boundaries around this point!";
                newel.setAttribute("date",instance[i]);
                newel.addEventListener("contextmenu", (e) => {
                    e.preventDefault();
                    let time = new Date(e.target.getAttribute("date"));
                    updateTimeLimits(time);
                });
                break;
            case "source":
                if(instance.type!="Chat")break;
                newel.classList.add("contextable");
                newel.setAttribute("source",instance[i]);
                newel.addEventListener("contextmenu", (e) => {
                    e.preventDefault();
                    document.getElementById("chatSource").value=e.target.getAttribute("source");
                    regenerateFiltered();
                });
                break;

        }
        const itemDetailsSizeDropoff = 3000;
        if(newel.textContent.length>itemDetailsSizeDropoff){
            let fontSize = (100*itemDetailsSizeDropoff/newel.textContent.length);
            const minFontSize=20;
            if(fontSize>minFontSize){newel.style.fontSize=fontSize+"%";}
            else{newel.style.fontSize=minFontSize+"%";}
        }
        itemDetails.appendChild(newel);
    }
}

document.getElementById("regenerate").addEventListener("click", regenerateFiltered);
function regenerateFiltered(){
    // Regenerate using timelineFiltered
    if(timeline==undefined){alert("Add a timeline file first!");return;}

    timelineFiltered = applyFilters(timeline, compileFilters());
    
    regenerateTimeline(timelineFiltered, timelineElement);
}

function updateTimeLimits(time){
    const timelineLimitLower = document.getElementById("limitdate1");
    const timelineLimitUpper = document.getElementById("limitdate2");
    const timeDifferenceHours = 24;
    let newTimeLower = time;
    newTimeLower.setHours(time.getHours()-timeDifferenceHours);
    timelineLimitLower.value = formatSetDate(newTimeLower);

    let newTimeUpper = time;
    newTimeUpper.setHours(time.getHours()+timeDifferenceHours);
    newTimeUpper.setDate(time.getDate()+1); // Because limits are currently dates without time, offby1
    timelineLimitUpper.value = formatSetDate(newTimeUpper);

    console.log("Adjusted timeline limits to surround time: "+time);
    regenerateFiltered();
}

document.getElementById("reset").addEventListener("click", (e) => {
    document.getElementById("limitdate1").value=formatSetDate(timeline[0].date);
    document.getElementById("limitdate2").value=formatSetDate(timeline[timeline.length-1].date);
    regenerateFiltered();
});

// Looks like locations aren't quite as simple as picking one nearest the time
// On smart devices, available for latest and a select few times in device history
// On old devices, unavailable

/* 
When file uploaded:
- Display summary information (case/evidence number not relevant) in corner
- Organise sheet data into folders
- Organise folders into timeline, order by time ascending
- Filter out items from timeline that don't count

To make timeline visual:
- Clear old timeline
- Draw line between left/right sides
- Get times of earliest/latest events
- For each event
    - Calculate percentage through timeline
    - Use percentage for distance across visual
    - Place marker on distance
    - Colour marker according to type
    - Set onclick to expand/retract connected info
    - Set clicking info to add/remove info to filters if available



Start writeup on analysis and design chapters
Initial prototypes were mockups

Add dropdown to email sender/reciever /callno for all emails used in dataset
Filter by app asking for location (/time difference?)

Potential for creating a map of locations?
How to present details examined in selected/hovered markers left up to me

XRY used to develop Nokia phone data
XRY is quick whereas Cellebrite is more complex

Smartphones were extracted with Graykey (also used for bruteforcing phones)
Excel spreadsheets are then developed with cellebrite

ITERATION 4 

Before generating timeline, find whether the sheets are the correct ones
New format of sheetMap, use to store which sheet is which 
sheetMap {
    summary: 0,
    calls:3,
    emails:7,
    locations:null, <- points marked with null do not exist, therefore we can skip them
    webhist:2
}

Add paragraph to methodology about how it's being evaluated

options for evaluation <- give them, cognitive walkthrough, take notes
- test script, have them walk through specific tasks
- Give them it, questionnaire about usability, interview for what did or did not work

*/

//document.getElementById().getEventListener("contextmenu"){}

function findSheetMap(list){
    let ret = {
        summary:null,
        calls:null,
        chats:null,
        contacts:null,
        deviceInfo:null,
        users:null,
        emails:null,
        locations:null,
        searchedItems:null,
        webHistory:null,
        // These ones exclusive to the Nokia dataset
        nokiaCalls:null,
        nokiaSMS:null,
        // These ones exclusive to the old (Cellebrite) dataset
        appUsage:null,
        cookies:null,
        connectivity:null,
        events:null,
        notifications:null,
        downloads:null,
        uploads:null,
        apps:null,
        instantMessages:null,
        networkUsages:null,
        passwords:null,
        socialMedia:null,
        dictionary:null,
        bookmarks:null
        // Note that the old dataset has a timeline which we're not using because we're compiling it ourselves.
    };
    for(let i=0;i<list.length;i++){ // This sucks. However, it is functionally an improvement.
        switch(list[i].sheet){
            case "Summary":
                ret.summary=i;
                break;
            case "Call Log":
                ret.calls=i;
                break;
            case "Chats":
                ret.chats=i;
                break;
            case "Contacts":
                ret.contacts=i;
                break;
            case "Device Info":
                ret.deviceInfo=i;
                break;
            case "Device Users":
                ret.users=i;
                break;
            case "Emails":
                ret.emails=i;
                break;
            case "Locations":
                ret.locations=i;
                break;
            case "Searched Items":
                ret.searchedItems=i;
                break;
            case "Web History":
                ret.webHistory=i;
                break;
            case "Calls":
                if(list[0].sheet=="Case"){ // Double-check the dataset is using the Nokia dataset's format
                    ret.nokiaCalls=i;
                }
                break;
            case "Messages SMS":
                if(list[0].sheet=="Case"){
                    ret.nokiaSMS=i;
                }
                break;
        }
    }
    return ret;
}

// Don't care about [0], it's the title
// [1] is the names so use that to dynamic-ify
function addSheetCall(list){
    let map = {
        from:null,
        date:null,
        country:null,
        prefix:null,
        duration:null,
        direction:null,
        status:null,
        name:null,
        number:null
    };
    for(let i=0;i<list[1].length;i++){
        switch(list[1][i]){
            case "Date":
                map.date=i;
                break;
            case "Parties":
                map.from=i;
                break;
            case "Source":
                map.name=i;
                break;
            case "Account":
                map.number=i;
                break;
            case "Direction":
                map.direction=i;
                break;
            case "Status":
                map.status=i;
                break;
            case "Country code":
                map.country=i;
                break;
            case "Duration":
                map.duration=i;
                break;
            case "International Prefix":
                map.prefix=i;
                break;
        }
    }
    let ret = [];
    let skipped = [];
    for(let i=2;i<list.length;i++){
        if(!list[i][map.date]){
            //console.warn("Skipping call due to missing date: "+i);
            skipped.push(i);
            continue;
        }

        let append = {
            country:list[i][map.country],
            prefix:list[i][map.prefix],
            from:list[i][map.from],
            date:list[i][map.date],
            duration:list[i][map.duration],
            direction:list[i][map.direction],
            status:list[i][map.status],
            name:list[i][map.name],
            number:list[i][map.number],
            type:"Call"
        }
        ret.push(append);
    }
    if(skipped.length>0){
        console.warn("Skipped calls due to missing date: "+skipped);
    }
    return ret;
}

function addSheetEmail(list){
    let map = {
        sender:null,
        reciever:null,
        cc:null,
        bcc:null,
        date:null,
        subject:null,
        body:null,
        read:null,
        source:null,
        folder:null,
    };
    for(let i=0;i<list[1].length;i++){
        switch(list[1][i]){
            case "Time":
                map.date=i;
                break;
            case "From":
                map.sender=i;
                break;
            case "To":
                map.reciever=i;
                break;
            case "CC":
                map.cc=i;
                break;
            case "BCC":
                map.bcc=i;
                break;
            case "Subject":
                map.subject=i;
                break;
            case "Body":
                map.body=i;
                break;
            case "Status":
                map.read=i;
                break;
            case "Source":
                map.source=i;
                break;
            case "Folder":
                map.folder=i;
                break;
        }
    }
    let ret = [];
    let skipped = [];
    for(let i=2;i<list.length;i++){
        if(!list[i][map.date]){
            //console.warn("Skipping email due to missing date: "+i);
            skipped.push(i);
            continue;
        }

        let append = {
            date:formatLocDate(list[i][map.date]),
            sender:list[i][map.sender],
            reciever:list[i][map.reciever],
            cc:list[i][map.cc],
            bcc:list[i][map.bcc],
            subject:list[i][map.subject],
            body:list[i][map.body],
            read:list[i][map.read]=="Read",
            source:list[i][map.read],
            folder:list[i][map.folder],
            type:"Email"
        }
        ret.push(append);
    }
    if(skipped.length>0){
        console.warn("Skipped emails due to missing date: "+skipped);
    }
    return ret;
}

function addSheetChat(list){
    let map = {
        date:null,
        source:null,
        from:null,
        to:null,
        body:null,
        deleted:null,
        starred:null,
        carved:null,
    };
    for(let i=0;i<list[1].length;i++){
        switch(list[1][i]){
            case "Start Time: Time":
                map.date=i;
                break;
            case "Source":
                map.source=i;
                break;
            case "From":
                map.from=i;
                break;
            case "To":
                map.to=i;
                break;
            case "Body":
                map.body=i;
                break;
            case "Deleted - Instant Message":
                map.deleted=i;
                break;
            case "Starred message":
                map.starred=i;
                break;
            case "Message Carved":
                map.carved=i;
                break;
        };
    }
    let ret = [];
    let skipped = [];
    for(let i=2;i<list.length;i++){
        if(!list[i][map.date]){
            //console.warn("Skipping chat message due to missing date: "+i);
            skipped.push(i);
            continue;
        }

        let append = {
            date:formatLocDate(list[i][map.date]),
            source:list[i][map.source],
            from:list[i][map.from],
            to:list[i][map.to],
            body:list[i][map.body],
            deleted:formatYNToBinary(list[i][map.deleted]),
            starred:formatYNToBinary(list[i][map.starred]),
            carved:formatYNToBinary(list[i][map.carved]),
            type:"Chat"
        }
        ret.push(append);
    }
    if(skipped.length>0){
        console.warn("Skipped chat messages due to missing date: "+skipped);
    }
    return ret;
}

function addSheetLocation(list){
    let map = {
        date:null,
        postcode:null,
        category:null,
        latitude:null,
        longitude:null,
        deleted:null,
        address:null,
        source:null
    };
    for(let i=0;i<list[1].length;i++){
        switch(list[1][i]){
            case "Address":
                map.address=i;
                break;
            case "Name":
                map.postcode=i;
            case "Time":
                map.date=i;
                break;
            case "Category":
                map.category=i;
                break;
            case "Latitude":
                map.latitude=i;
                break;
            case "Longitude":
                map.longitude=i;
                break;
            case "Deleted":
                map.deleted=i;
                break;
            case "Source":
                map.source=i;
                break;
        };
    }
    let ret = [];
    let skipped = [];
    for(let i=2;i<list.length;i++){
        if(!list[i][map.date]){
            //console.warn("Skipping location due to missing date: "+(i-2));
            skipped.push(i);
            continue;
        }

        let append = {
            date:formatLocDate(list[i][map.date]),
            source:list[i][map.source],
            address:list[i][map.address],
            latitude:list[i][map.latitude],
            longitude:list[i][map.longitude],
            postcode:list[i][map.postcode],
            category:list[i][map.category],
            deleted:formatYNToBinary(list[i][map.deleted]),
            type:"Location"
        }
        ret.push(append);
    }
    if(skipped.length>0){
        console.warn("Skipped locations due to missing date: "+skipped);
    }
    return ret;
}

function addSheetWebHistory(list){
    let map = {
        date:null,
        url:null,
        title:null,
        pattern:null,
        account:null,
        source:null,
        deleted:null,
        SID:null
    };
    for(let i=0;i<list[1].length;i++){
        switch(list[1][i]){
            case "Title":
                map.title=i;
                break;
            case "URL":
                map.url=i;
                break;
            case "Last Visited-Time":
                map.date=i;
                break;
            case "Account":
                map.account=i;
                break;
            case "Source":
                map.source=i;
                break;
            case "Usage Pattern":
                map.pattern=i;
                break;
            case "Deleted":
                map.deleted=i;
                break;
            case "SID":
                map.SID=i;
                break;
        };
    }
    let ret = [];
    let skipped = [];
    for(let i=2;i<list.length;i++){
        if(!list[i][map.date]){
            //console.warn("Skipping web event due to missing date: "+(i-2));
            skipped.push(i);
            continue;
        }

        let append = {
            date:formatLocDate(list[i][map.date]),
            url:list[i][map.url],
            title:list[i][map.title],
            pattern:list[i][map.pattern],
            account:list[i][map.account],
            source:list[i][map.source],
            SID:list[i][map.SID],
            deleted:formatYNToBinary(list[i][map.deleted]),
            type:"Web History"
        }
        ret.push(append);
    }
    if(skipped.length>0){
        console.warn("Skipped web events due to missing date: "+skipped);
    }
    return ret;
}

function addSheetNokiaCall(list){
    let map = {
        date:null,
        callType:null,
        to:null,
        from:null,
        duration:null,
        direction:null
    };
    for(let i=0;i<list[0].length;i++){ // Nokia set uses a different tool with proper sheets
        switch(list[0][i]){
            case "Call Type":
                map.callType=i;
                break;
            case "Time":
                map.date=i;
                break;
            case "To":
                map.to=i;
                break;
            case "From":
                map.from=i;
                break;
            case "Duration":
                map.duration=i;
                break;
            case "Direction":
                map.direction=i;
                break;
        }
    }
    let ret = [];
    let skipped = [];
    for(let i=1;i<list.length;i++){
        if(!list[i][map.date]){
            //console.warn("Skipping call due to missing date: "+i);
            skipped.push(i);
            continue;
        }

        let append = {
            date:formatLocDate(list[i][map.date]),
            callType:list[i][map.callType],
            to:list[i][map.to],
            from:list[i][map.from],
            duration:list[i][map.duration],
            direction:list[i][map.direction],
            type:"Burner Call"
        }
        ret.push(append);
    }
    if(skipped.length>0){
        console.warn("Skipped burner calls due to missing date: "+skipped);
    }
    return ret;
}

function addSheetNokiaSMS(list){
    let map = {
        date:null,
        direction:null,
        to:null,
        from:null,
        body:null,
        deleted:null
    };
    for(let i=0;i<list[0].length;i++){ // Nokia set uses a different tool with proper sheets
        switch(list[0][i]){
            case "Direction":
                map.direction=i;
                break;
            case "To":
                map.to=i;
                break;
            case "From":
                map.from=i;
                break;
            case "Time":
                map.date=i;
                break;
            case "Text":
                map.body=i;
                break;
            case "Deleted":
                map.deleted=i;
                break;
        }
    }
    let ret = [];
    skipped = [];
    for(let i=1;i<list.length;i++){
        if(!list[i][map.date]){
            //console.warn("Skipping SMS message due to missing date: "+i);
            skipped.push(i);
            continue;
        }

        let append = {
            date:formatLocDate(list[i][map.date]),
            deleted:formatYNToBinary(list[i][map.deleted]),
            to:list[i][map.to],
            from:list[i][map.from],
            body:list[i][map.body],
            direction:list[i][map.direction],
            type:"Burner SMS"
        }
        ret.push(append);
    }
    if(skipped.length>0){
        console.warn("Skipped burner messages due to missing date: "+skipped);
    }
    return ret;
}

function compileSheets(list){
    let sheetMap = findSheetMap(list);
    let ret = [];
    if(sheetMap.emails){
        ret=ret.concat(addSheetEmail(list[sheetMap.emails].data));
    }
    if(sheetMap.calls){
        ret=ret.concat(addSheetCall(list[sheetMap.calls].data));
    }
    if(sheetMap.chats){
        ret=ret.concat(addSheetChat(list[sheetMap.chats].data));
    }
    if(sheetMap.locations){
        ret=ret.concat(addSheetLocation(list[sheetMap.locations].data));
    }
    if(sheetMap.webHistory){
        ret=ret.concat(addSheetWebHistory(list[sheetMap.webHistory].data));
    }
    if(sheetMap.nokiaCalls){
        ret=ret.concat(addSheetNokiaCall(list[sheetMap.nokiaCalls].data));
    }
    if(sheetMap.nokiaSMS){
        ret=ret.concat(addSheetNokiaSMS(list[sheetMap.nokiaSMS].data));
    }
    ret=sortByDate(ret);
    return ret;
}

function compileFilters(){
    let ret = {
        timeline:{
            limitLower:null,
            limitUpper:null
        },
        Call:{
            enabled:false,
            number:null
        },
        Email:{
            enabled:false,
            sender:null,
            reciever:null
        },
        Chat:{
            enabled:false,
            source:null,
            from:null,
            bodyText:null
        },
        Location:{
            enabled:false,
            source:null,
            timeVariance:null
        },
        "Web History":{
            enabled:false,
            source:null,
            url:null,
            onlyShowDeleted:false
        },
        "Last User Activity":{
            enabled:false
        },
        "Burner Call":{
            enabled:false
        },
        "Burner SMS":{
            enabled:false
        }
    };
    for(const i of filtertypes.children){
        if(i.checked){
            ret[i.getAttribute("filtertype")].enabled=true;
        }
    }
    const timelineLimitLower = document.getElementById("limitdate1");
    const timelineLimitUpper = document.getElementById("limitdate2");
    ret.timeline.limitLower = new Date(timelineLimitLower.value);
    ret.timeline.limitUpper = new Date(timelineLimitUpper.value);
    ret.timeline.limitUpper.setDate(ret.timeline.limitUpper.getDate()+1); // Account for date input off-by-one

    if(ret["Email"].enabled){
        const emailSender = document.getElementById("emailSender");
        const emailReciever = document.getElementById("emailReciever");
        if(emailSender.value!=""){
            ret["Email"].sender=emailSender.value;
        }
        if(emailReciever.value!=""){
            ret["Email"].reciever=emailReciever.value;
        }
    }
    if(ret["Call"].enabled){
        const callNumber = document.getElementById("callNumber");
        if(callNumber.value!=""){
            ret["Call"].number=callNumber.value;
        }
    }
    if(ret["Chat"].enabled){
        const chatSource = document.getElementById("chatSource");
        const chatBodyText = document.getElementById("chatBodyText");
        if(chatSource.value!=""){
            ret["Chat"].source=chatSource.value;
        }
        if(chatBodyText.value!=""){
            ret["Chat"].bodyText=chatBodyText.value;
        }
    }
    if(ret["Web History"].enabled){/*ditto*/}
    return ret;
}

function applyFilters(timeline, filters){
    let ret = [];
    for(let i=0;i<timeline.length;i++){
        const item = timeline[i];
        if(filters[item.type].enabled 
            && filters.timeline.limitLower<=item.date
            && filters.timeline.limitUpper>=item.date
        ){

            let push=false;
            switch(item.type){ // type-specific filters
                case "Email":
                    if(filters["Email"].sender!=null && filters["Email"].sender!=item.sender){break;}
                    if(filters["Email"].reciever!=null && filters["Email"].reciever!=item.reciever){break;}
                    push=true;
                    break;
                case "Call":
                    if(filters["Call"].number!=null && filters["Call"].number!=item.number){break;}
                    push=true;
                    break;
                case "Chat":
                    if(filters["Chat"].source!=null && filters["Chat"].source!=item.source){break;}
                    if(filters["Chat"].bodyText!=null){
                        if(item.body==null){break;}
                        if(!item.body.includes(filters["Chat"].bodyText)){break;}
                    }
                    push=true;
                    break;
                default:
                    push=true;
            }
            if(push)ret.push(item);
        }
    }
    return ret;
}

// We can't easily test automatically due to data requirements, but we can use a function after data is provided
function runTests(list){
    console.log("TEST BLOCK");
    let sheetMap = findSheetMap(list);
    console.log(sheetMap);
    if(sheetMap.emails){
        console.log("EMAILS");
        console.log(addSheetEmail(list[sheetMap.emails].data));
    }
    if(sheetMap.calls){
        console.log("CALLS");
        console.log(addSheetCall(list[sheetMap.calls].data));
    }
    if(sheetMap.chats){
        console.log("CHATS");
        console.log(addSheetChat(list[sheetMap.chats].data));
    }
    if(sheetMap.locations){
        console.log("LOCATIONS");
        console.log(addSheetLocation(list[sheetMap.locations].data));
    }
    if(sheetMap.webHistory){
        console.log("WEB HISTORY");
        console.log(addSheetWebHistory(list[sheetMap.webHistory].data));
    }
    if(sheetMap.nokiaCalls){
        console.log("NOKIA CALLS");
        console.log(addSheetNokiaCall(list[sheetMap.nokiaCalls].data));
    }
    if(sheetMap.nokiaSMS){
        console.log("NOKIA SMS");
        console.log(addSheetNokiaSMS(list[sheetMap.nokiaSMS].data));
    }
    console.log("WHOLE");
    let compiled = compileSheets(list);
    console.log(compiled);

    console.log("FILTERS");
    let filt = compileFilters();
    console.log(filt);

    console.log("FILTERED TIMELINE");
    console.log(applyFilters(compiled, filt));

    console.log("END TEST BLOCK");
}